/*LIBRARY*/
import { Component } from "react";
import { connect } from "react-redux";

/*COMPONENT*/

/*REDUX*/
import { edit_folder_project } from "../../App/actions/folderProjectAction";

/*PICTURE*/

/*FUNCTION*/

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/

class EDIT_FOLDER_PROJECT extends Component {
  state = {
    name: "",
  };

  componentDidMount() {
    const folder = { ...this.props.folder };
    this.setState({ ...folder });
  }

  on_change = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  on_submit = (e) => {
    e.preventDefault();
    const { _id } = this.state;
    const { folder_object_selected_list } = this.props.project;
    const key =
      folder_object_selected_list.length > 0
        ? "folder_project_child_list"
        : "folder_project_list";
    const body = {
      folder_id: _id,
      key,
      ...this.state,
    };
    this.props.edit_folder_project(body);
    this.props.toggle_edit_folder();
  };

  render() {
    //local storage
    const language = localStorage?.language || this.props.auth.language;

    //local state
    const { name } = this.state;

    //global props

    //content
    return (
      <main>
        <form onSubmit={this.on_submit}>
          <h2 className="margin_bottom">{dict?.["Edit folder"]?.[language]}</h2>
          <p>{dict?.["Enter a folder name"]?.[language]}</p>
          <input
            name="name"
            value={name}
            onChange={this.on_change}
            type="text"
            className="margin_bottom"
          />
          <br />
          <button type="submit" className="button background_black margin_top">
            {dict?.["Save"]?.[language]}
          </button>
        </form>
      </main>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  project: state.project,
});

export default connect(mapStateToProps, { edit_folder_project })(
  EDIT_FOLDER_PROJECT
);
